import roleName from './role-name.js';
import tagImage from './tag-image.js';
import tagName from './tag-name.js';

export default {
    roleName,
    tagImage,
    tagName
};
